import { AxiosError } from 'axios';

export const isAxiosError = (err: any): err is AxiosError =>
  'name' in err && err.name === 'AxiosError';
